import { DataFeedFileType } from '@cbinsights/externalapiservice/externalapiservice';
import { Typography } from 'antd';
import { fileTypeToNumber } from './DataFeedForm';
import { useGetOptionalColumnCatalog } from './OptionalColumnsSelector';

const { Text } = Typography;

const ColumnsList = ({
  label,
  columns,
}: {
  label: string;
  columns: string[];
}) => (
  <div className="border-l border-gray-600 pl-2 mb-2 last:mb-0">
    <Text type="secondary">{label}</Text>
    <ul className="list-disc ml-4" style={{ columns: 2 }}>
      {columns.map((col) => (
        <li key={col}>{col}</li>
      ))}
    </ul>
  </div>
);

export const formatOptionalColumnCount = (count: number) =>
  `${count} optional ${count === 1 ? 'column' : 'columns'}`;

export const FeedOptionalColumns = ({ columns }: { columns: string[] }) =>
  columns.length ? (
    <ul className="list-disc ml-4" style={{ columns: 2 }}>
      {columns.map((col) => (
        <li key={col}>{col}</li>
      ))}
    </ul>
  ) : (
    <Text>No optional columns included</Text>
  );

export const OptionalColumnsSummary = ({
  fileType,
  columns,
}: {
  fileType: DataFeedFileType;
  columns?: string[];
}) => {
  const { data: catalog } = useGetOptionalColumnCatalog();
  const allColumns = catalog?.[fileTypeToNumber(fileType)];

  if (!allColumns?.length || columns === undefined) {
    return null;
  }

  const included = allColumns.filter((col) => columns.includes(col));
  const excluded = allColumns.filter((col) => !columns.includes(col));

  if (!excluded.length) {
    return <Text className="text-xs">All optional columns included</Text>;
  }

  if (!included.length) {
    return <Text className="text-xs">No optional columns included</Text>;
  }

  return (
    <details>
      <summary className="cursor-pointer">
        <Text className="text-xs">
          {included.length} / {allColumns.length} optional columns included
        </Text>
      </summary>
      <div className="text-xs mt-1">
        <ColumnsList label="Included" columns={included} />
        <ColumnsList label="Excluded" columns={excluded} />
      </div>
    </details>
  );
};
